import { http } from "./http";

export type WholesaleBreak = { min_qty: number; price: number };

export type OrderProductVariantSearchResult = {
  id: number;
  sku?: string | null;
  variant_name?: string | null;
  price: number;
  image_url?: string | null;
  attributes?: any[];
  available_stock?: number;
  stock_type?: "online" | "in_store";
  location_id?: number;
  stock_summary?: any[];
  // Present only when the search was run with a wholesale tier.
  wholesale_price?: number | null;
  wholesale_min_qty?: number | null;
  wholesale_breaks?: WholesaleBreak[] | null;
};

export type OrderProductSearchResult = {
  product_id: number;
  product_name: string;
  product_image?: string | null;
  supplier_price?: number | string | null;
  variants: OrderProductVariantSearchResult[];
  wholesale_price?: number | null;
  wholesale_min_qty?: number | null;
  wholesale_breaks?: WholesaleBreak[] | null;
};

export const searchOrderProducts = async (
  orderId: number,
  query: string
): Promise<OrderProductSearchResult[]> => {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const res = await http.get(`/orders/${orderId}/product-search`, {
    params: { query: trimmed },
  });

  return Array.isArray(res.data) ? res.data : [];
};

export const searchProductsForAdminOrderCreate = async (
  query: string,
  tierId?: number | null
): Promise<OrderProductSearchResult[]> => {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const res = await http.get(`/orders/admin-create-product-search`, {
    params: {
      query: trimmed,
      location_id: 1,
      stock_type: "online",
      ...(tierId ? { tier_id: tierId } : {}),
    },
  });

  return Array.isArray(res.data) ? res.data : [];
};